<template>
  <header class="row center">
    <div class="header__container row">
      <Logo />
      <Dropdown />
    </div>
  </header>
</template>

<script>
import Logo from './components/Logo.vue'
import Dropdown from './components/Dropdown.vue'

export default {
  name: 'Header',
  components: { Logo, Dropdown },
}
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  top: 0;
  background-color: white;
  height: 60px;
  width: 100%;
  z-index: 10;

  .header__container {
    width: calc(100% - 40px);
    padding: 0 20px;
    align-items: center;
    justify-content: space-between;
    max-width: 2000px;
  }
}
</style>
